import { UpdateProfileRequest } from '../../../core/interfaces/user-profile/user-profile.interface';

export class LoadUserProfileAction {
  static readonly type = '[UserProfile] Load Profile';
}

export class UpdateUserProfileAction {
  static readonly type = '[UserProfile] Update Profile';
  constructor(public payload: UpdateProfileRequest) {}
}

export class ClearUserProfileAction {
  static readonly type = '[UserProfile] Clear Profile';
}
